const Switch = ({
  checked = false,
  onChange,
  disabled = false,
  size = 'medium',
  id,
}) => {
  const sizeStyles = {
    small: { width: '36px', height: '20px' },
    medium: { width: '44px', height: '24px' },
    large: { width: '56px', height: '28px' },
  }

  const thumbSizes = {
    small: { width: '14px', height: '14px' },
    medium: { width: '20px', height: '20px' },
    large: { width: '24px', height: '24px' },
  }

  const switchStyle = {
    ...sizeStyles[size],
    position: 'relative',
    display: 'inline-block',
    border: '2px solid transparent',
    borderRadius: '50px',
    backgroundColor: checked ? '#7F56D9' : '#F2F4F7',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.65 : 1,
    transition:
      'background-color 0.2s ease-in-out, box-shadow 0.15s ease-in-out',
    padding: 0,
    outline: 'none',
  }

  const thumbStyle = {
    ...thumbSizes[size],
    position: 'absolute',
    top: '0px',
    left: checked ? `calc(100% - ${thumbSizes[size].width} - 2px)` : '2px',
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    transition: 'left 0.2s ease-in-out',
  }

  const handleKeyDown = (e) => {
    // Support Space and Enter keys
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault()
      if (!disabled) {
        onChange?.(!checked)
      }
    }
  }

  return (
    <button
      type='button'
      role='switch'
      id={id}
      style={switchStyle}
      aria-checked={checked}
      aria-label='Toggle Switch'
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      onKeyDown={handleKeyDown}
      onFocus={(e) => {
        e.currentTarget.style.boxShadow = checked
          ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)'
          : '0 0 0 0.25rem rgba(108, 117, 125, 0.25)'
      }}
      onBlur={(e) => {
        e.currentTarget.style.boxShadow = 'none'
      }}
    >
      <span style={thumbStyle} aria-hidden='true' />
    </button>
  )
}

export default Switch
